/**
 * Aztrix
 * Smart address book for individuals and organisations, respecting privacy.
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Type {
  propertyType?: Type.PropertyTypeEnum;
  value?: boolean;
}
export namespace Type {
  export type PropertyTypeEnum =
    | 'USERNAME'
    | 'FIRST_NAME'
    | 'MIDDLE_NAME'
    | 'LAST_NAME'
    | 'NAME'
    | 'AVATAR'
    | 'GENDER'
    | 'BIRTHDAY'
    | 'FOUNDED'
    | 'DISSOLVED'
    | 'DAY'
    | 'MONTH'
    | 'YEAR'
    | 'EMAIL'
    | 'MOBILE_PHONE'
    | 'PHONE'
    | 'FAX'
    | 'WEBSITE'
    | 'BIC'
    | 'JOB_TITLE'
    | 'INDUSTRY'
    | 'GROUP'
    | 'REGION'
    | 'ADDRESS'
    | 'STREET'
    | 'COUNTRY'
    | 'BUILDING'
    | 'BOX'
    | 'LOCALITY'
    | 'NUMBER'
    | 'ZIP'
    | 'DISTRICT'
    | 'PROVINCE'
    | 'SUBURB'
    | 'STATE'
    | 'COUNTY'
    | 'LAT_LONG'
    | 'FACEBOOK'
    | 'YOUTUBE'
    | 'INSTAGRAM'
    | 'WHATSAPP'
    | 'WECHAT'
    | 'TIKTOK'
    | 'FACEBOOK_MESSENGER'
    | 'TELEGRAM'
    | 'SNAPCHAT'
    | 'PINTEREST'
    | 'TWITTER'
    | 'REDDIT'
    | 'LINKEDIN'
    | 'VIMEO'
    | 'DISCORD'
    | 'TWITCH'
    | 'TUMBLR'
    | 'MASTODON'
    | 'PATREON'
    | 'KICKSTARTER'
    | 'INDIEGOGO'
    | 'GOFUNDME'
    | 'TAKEAWAY'
    | 'UBEREATS'
    | 'DELIVEROO'
    | 'SHIPTO'
    | 'WEIBO'
    | 'QQ'
    | 'KUAISHOU'
    | 'QZONE'
    | 'SKYPE'
    | 'NOTE'
    | 'ORGANISATION_NAME'
    | 'LEGAL_NAME'
    | 'LEGAL_FORM'
    | 'LEGAL_ID'
    | 'COMPANY_NUMBER'
    | 'JURISDICTION'
    | 'IMPORT_SOURCE'
    | 'PROPOSAL'
    | 'CATEGORY'
    | 'OPENING_HOURS'
    | 'CUSTOM'
    | 'FILE'
    | 'IMAGE'
    | 'FILE_KEY'
    | 'FILE_NAME'
    | 'TERMS_AND_CONDITIONS'
    | 'PRIVACY_POLICY'
    | 'DOCUMENT'
    | 'DOCUMENT_NAME'
    | 'ORGANISATION_TYPE';
  export const PropertyTypeEnum = {
    USERNAME: 'USERNAME' as PropertyTypeEnum,
    FIRST_NAME: 'FIRST_NAME' as PropertyTypeEnum,
    MIDDLE_NAME: 'MIDDLE_NAME' as PropertyTypeEnum,
    LAST_NAME: 'LAST_NAME' as PropertyTypeEnum,
    NAME: 'NAME' as PropertyTypeEnum,
    AVATAR: 'AVATAR' as PropertyTypeEnum,
    GENDER: 'GENDER' as PropertyTypeEnum,
    BIRTHDAY: 'BIRTHDAY' as PropertyTypeEnum,
    FOUNDED: 'FOUNDED' as PropertyTypeEnum,
    DISSOLVED: 'DISSOLVED' as PropertyTypeEnum,
    DAY: 'DAY' as PropertyTypeEnum,
    MONTH: 'MONTH' as PropertyTypeEnum,
    YEAR: 'YEAR' as PropertyTypeEnum,
    EMAIL: 'EMAIL' as PropertyTypeEnum,
    MOBILE_PHONE: 'MOBILE_PHONE' as PropertyTypeEnum,
    PHONE: 'PHONE' as PropertyTypeEnum,
    FAX: 'FAX' as PropertyTypeEnum,
    WEBSITE: 'WEBSITE' as PropertyTypeEnum,
    BIC: 'BIC' as PropertyTypeEnum,
    JOB_TITLE: 'JOB_TITLE' as PropertyTypeEnum,
    INDUSTRY: 'INDUSTRY' as PropertyTypeEnum,
    GROUP: 'GROUP' as PropertyTypeEnum,
    REGION: 'REGION' as PropertyTypeEnum,
    ADDRESS: 'ADDRESS' as PropertyTypeEnum,
    STREET: 'STREET' as PropertyTypeEnum,
    COUNTRY: 'COUNTRY' as PropertyTypeEnum,
    BUILDING: 'BUILDING' as PropertyTypeEnum,
    BOX: 'BOX' as PropertyTypeEnum,
    LOCALITY: 'LOCALITY' as PropertyTypeEnum,
    NUMBER: 'NUMBER' as PropertyTypeEnum,
    ZIP: 'ZIP' as PropertyTypeEnum,
    DISTRICT: 'DISTRICT' as PropertyTypeEnum,
    PROVINCE: 'PROVINCE' as PropertyTypeEnum,
    SUBURB: 'SUBURB' as PropertyTypeEnum,
    STATE: 'STATE' as PropertyTypeEnum,
    COUNTY: 'COUNTY' as PropertyTypeEnum,
    LAT_LONG: 'LAT_LONG' as PropertyTypeEnum,
    FACEBOOK: 'FACEBOOK' as PropertyTypeEnum,
    YOUTUBE: 'YOUTUBE' as PropertyTypeEnum,
    INSTAGRAM: 'INSTAGRAM' as PropertyTypeEnum,
    WHATSAPP: 'WHATSAPP' as PropertyTypeEnum,
    WECHAT: 'WECHAT' as PropertyTypeEnum,
    TIKTOK: 'TIKTOK' as PropertyTypeEnum,
    FACEBOOK_MESSENGER: 'FACEBOOK_MESSENGER' as PropertyTypeEnum,
    TELEGRAM: 'TELEGRAM' as PropertyTypeEnum,
    SNAPCHAT: 'SNAPCHAT' as PropertyTypeEnum,
    PINTEREST: 'PINTEREST' as PropertyTypeEnum,
    TWITTER: 'TWITTER' as PropertyTypeEnum,
    REDDIT: 'REDDIT' as PropertyTypeEnum,
    LINKEDIN: 'LINKEDIN' as PropertyTypeEnum,
    VIMEO: 'VIMEO' as PropertyTypeEnum,
    DISCORD: 'DISCORD' as PropertyTypeEnum,
    TWITCH: 'TWITCH' as PropertyTypeEnum,
    TUMBLR: 'TUMBLR' as PropertyTypeEnum,
    MASTODON: 'MASTODON' as PropertyTypeEnum,
    PATREON: 'PATREON' as PropertyTypeEnum,
    KICKSTARTER: 'KICKSTARTER' as PropertyTypeEnum,
    INDIEGOGO: 'INDIEGOGO' as PropertyTypeEnum,
    GOFUNDME: 'GOFUNDME' as PropertyTypeEnum,
    TAKEAWAY: 'TAKEAWAY' as PropertyTypeEnum,
    UBEREATS: 'UBEREATS' as PropertyTypeEnum,
    DELIVEROO: 'DELIVEROO' as PropertyTypeEnum,
    SHIPTO: 'SHIPTO' as PropertyTypeEnum,
    WEIBO: 'WEIBO' as PropertyTypeEnum,
    QQ: 'QQ' as PropertyTypeEnum,
    KUAISHOU: 'KUAISHOU' as PropertyTypeEnum,
    QZONE: 'QZONE' as PropertyTypeEnum,
    SKYPE: 'SKYPE' as PropertyTypeEnum,
    NOTE: 'NOTE' as PropertyTypeEnum,
    ORGANISATION_NAME: 'ORGANISATION_NAME' as PropertyTypeEnum,
    LEGAL_NAME: 'LEGAL_NAME' as PropertyTypeEnum,
    LEGAL_FORM: 'LEGAL_FORM' as PropertyTypeEnum,
    LEGAL_ID: 'LEGAL_ID' as PropertyTypeEnum,
    COMPANY_NUMBER: 'COMPANY_NUMBER' as PropertyTypeEnum,
    JURISDICTION: 'JURISDICTION' as PropertyTypeEnum,
    IMPORT_SOURCE: 'IMPORT_SOURCE' as PropertyTypeEnum,
    PROPOSAL: 'PROPOSAL' as PropertyTypeEnum,
    CATEGORY: 'CATEGORY' as PropertyTypeEnum,
    OPENING_HOURS: 'OPENING_HOURS' as PropertyTypeEnum,
    CUSTOM: 'CUSTOM' as PropertyTypeEnum,
    FILE: 'FILE' as PropertyTypeEnum,
    IMAGE: 'IMAGE' as PropertyTypeEnum,
    FILE_KEY: 'FILE_KEY' as PropertyTypeEnum,
    FILE_NAME: 'FILE_NAME' as PropertyTypeEnum,
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS' as PropertyTypeEnum,
    PRIVACY_POLICY: 'PRIVACY_POLICY' as PropertyTypeEnum,
    DOCUMENT: 'DOCUMENT' as PropertyTypeEnum,
    DOCUMENT_NAME: 'DOCUMENT_NAME' as PropertyTypeEnum,
    ORGANISATION_TYPE: 'ORGANISATION_TYPE' as PropertyTypeEnum,
  };
}
